export class Constants {
    
    public static PartyStateInterestedId = "4e9ac1e6-60c0-11ec-8607-0242ac130002";
    public static PartyStateActiveId = "63f299ba-60c0-11ec-8607-0242ac130002";
    public static PartyStateArchivedId = "6fc49e6e-60c0-11ec-8607-0242ac130002";
    
    public static WorkTaskRuleNewId = "f852beb0-601a-11ec-8607-0242ac130002";
    public static WorkTaskRuleActiveId = "324ddc4e-601b-11ec-8607-0242ac130002";
    public static WorkTaskRuleNotActiveId = "37015734-601b-11ec-8607-0242ac130002";

}